import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {NoteResponse} from "../../../../service/groups/groups-lessons/fetch-note/fetchNote";


const initialState = {
    note: '',
};

const noteSlice = createSlice({
    name: 'note',
    initialState,
    reducers: {
        updateNoteInStore: (state, action) => {
            state.note = action.payload;
        },
    },
});

export const { updateNoteInStore } = noteSlice.actions;

export const noteReducer = noteSlice.reducer;